module.exports = __webpack_public_path__ + "static/media/stubhub-mobile.53beb146.svg";